var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/FlatListDependencies.ts";
import * as t from 'io-ts';
import { BimElement } from './BimEntity/BimElement';
import { BimStandardSize } from './BimEntity/BimStandardSize';
import { BimFamily } from './BimEntity/BimFamily';
import { BaseClassifier } from './BaseClassifierRepo';
import { BimCategory, BimModel } from './BimEntity';
import { AssemblyClassifier, UserClassifier, UserClassifierGroup } from './UserClassifierRepo';
import { BimReference } from './BimReference';
import { AnonymousClassifier } from './AnonymousClassifier';
export var FlatDependency;

(function (_FlatDependency) {
  var type = _FlatDependency.type = t.recursion('FlatDependencyType', function () {
    return t.union([t.literal('AnonymousClassifier'), t.literal('BaseClassifier'), t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily'), t.literal('BimStandardSize'), t.literal('BimElement'), t.literal('AssemblyClassifier'), t.literal('UserClassifier'), t.literal('UserClassifierEmptyGroup'), t.literal('UserClassifierGroupWithGroups'), t.literal('UserClassifierGroupWithElements'), t.literal('BimModelReference'), t.literal('BimCategoryReference'), t.literal('BimFamilyReference'), t.literal('BimStandardSizeReference'), t.literal('BimElementReference')]);
  });
  var io = _FlatDependency.io = t.recursion('FlatDependency', function () {
    return t.union([BimModel.io, BimModel.NotLoaded.io, BimCategory.io, BaseClassifier.io, BimFamily.io, BimStandardSize.io, BimElement.io, AssemblyClassifier.io, UserClassifier.io, AnonymousClassifier.io, UserClassifierGroup.io, BimReference.io]);
  });
})(FlatDependency || (FlatDependency = {}));

export var FlatListDependencies;

(function (_FlatListDependencies) {
  var io = _FlatListDependencies.io = t.recursion('FlatListDependencies', function () {
    return t.type({
      items: t.array(t.intersection([t.type({
        parentId: t.union([t.number, t["null"]]),
        parentType: t.union([FlatDependency.type, t["null"]])
      }), FlatDependency.io]))
    }, 'FlatListDependencies');
  });
})(FlatListDependencies || (FlatListDependencies = {}));